import React from "react";
import styles from "./LoadingDialog.module.scss";
import classNames from "classnames";
import Dialog from "../Dialog/Dialog";
import CircleProgressBar from "../CircleProgressBar/CircleProgressBar";

export interface LoadingDialogProps {
  title: string;
}

class LoadingDialog extends React.Component<LoadingDialogProps> {

  render() {

    return (
      <Dialog
        id="ldLoadingDlg"
        icon={"x"}
        showCancel={false}
        showConfirm={false}
        onCancel={(object) => object===undefined}
        headerCssClassName={styles.Invisible}
        footerCssClassName={styles.Invisible}>

        <>
          <div id="ldLoadContent" className={styles.TitleLoad}>
            <label className={styles.Title}>
              {this.props.title}
            </label>
            <CircleProgressBar/>
            <label className={classNames(styles.Content, styles.CenterItems)}>
              {this.props.children}
            </label>
          </div>
        </>

      </Dialog>
    );
  }

}

export default LoadingDialog;
